import React, { createContext, useContext, ReactNode } from 'react';
import { 
  AuthAPI, 
  DocumentAPI, 
  FolderAPI, 
  PermissionAPI, 
  AnalyticsAPI, 
  NotificationAPI 
} from '../services/api';

// API Context Type
export interface ApiContextType {
  auth: typeof AuthAPI;
  documents: typeof DocumentAPI;
  folders: typeof FolderAPI;
  permissions: typeof PermissionAPI;
  analytics: typeof AnalyticsAPI;
  notifications: typeof NotificationAPI;
}

// Create context
const ApiContext = createContext<ApiContextType | undefined>(undefined);

// Provider component
interface ApiProviderProps {
  children: ReactNode;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({ children }) => {
  const value: ApiContextType = {
    auth: AuthAPI,
    documents: DocumentAPI,
    folders: FolderAPI,
    permissions: PermissionAPI,
    analytics: AnalyticsAPI,
    notifications: NotificationAPI,
  };

  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
};

// Hook to use API context
export const useApi = (): ApiContextType => {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
};